import style from './Transaction.css';
import Skeleton from '../../shared/Skeleton/Skeleton';

export default function TransactionSkeleton({ ...props }) {
  return (
    <div className={style['list-item']} {...props}>
      <span className={style['icon']}>
        <Skeleton width="40px" height="40px" radius="50%" />
      </span>
      <div className={style.content}>
        <span className={style.title}>
          <Skeleton width="167px" height="16px" radius="20px" />
        </span>

        <span className={style['subtitle-skeleton']}>
          <Skeleton width="167px" height="12px" radius="15px" />
        </span>
      </div>
      <div>
        <Skeleton width="65px" height="16px" radius="20px" />
      </div>
    </div>
  );
}
